import React from 'react';
import style from './style';
import EAIcon from '../../../components/common/EAIcon';
import i18next from 'i18next';
import moment from 'moment/moment';

const getExpirationDate = (date) => {
  const m = moment(date);
  return m.isValid()
    ? m.format('DD/MM/YYYY')
    : i18next.t('context.dataTable.noExpirationDate');
};

const ArchivedInfos = ({ label, expirationDate, updatedBy, motif }) => {
  const { classes } = style();

  return (
    <div className={classes.archiveWrapper}>
      <div className={classes.generalInfos}>
        <EAIcon
          icon={'context/archiveItem2'}
          className={classes.archivedItemIcon}
        />
        <div className={classes.archivedItemLabel}>{label}</div>
        <div className={classes.archivedItemInfos}>
          <div className={classes.archivedItemInfo}>
            <EAIcon icon={'context/contextTiers/remove_circle_outline'} />
            <span>
              {i18next.t('context.ficheContext.archivedStopAt')}
              <> </>
              {getExpirationDate(expirationDate)}
            </span>
          </div>
          <div className={classes.archivedItemInfo}>
            <EAIcon icon={'context/contextTiers/person'} />
            <span className={classes.archivedUpdatedBy}>
              {i18next.t('context.ficheContext.by')}
              <> </>
              {updatedBy.nom}
              <> </>
              {updatedBy.prenom}
            </span>
          </div>
        </div>
      </div>
      <div className={classes.motif}>
        <div className={classes.motifLabel}>{i18next.t('comment')}</div>
        <div className={classes.motifText}>
          {motif ? motif : i18next.t('notSpecified')}
        </div>
      </div>
    </div>
  );
};

export default ArchivedInfos;
